const priceFields = [
  'display_name',
  'model_type',
  'capabilities',
  'groups',
  'customer_prices',
  'offers',
  'source_directory_v107',
  'source_quotes',
  'site_origins_v1024',
];
const statisticsFields = [
  'has_data',
  'current_health',
  'success_rate',
  'stability_score',
  'usage_share',
  'average_elapsed_time',
  'average_first_response_time',
  'stream_rate',
  'last_activity_at',
  'has_sufficient_sample',
  'admin',
];

export function catalogSummaryV1020(data) {
  return data.models.map((item) => ({
    ...item,
    prices_state_v1020: 'pending',
    statistics_state_v1020: data.compact_v113 ? 'skipped' : 'pending',
  }));
}

export function mergeCatalogStageV1020(current, data, stage) {
  const byName = new Map(data.models.map((item) => [item.model_name, item]));
  const fields = stage === 'prices' ? priceFields : statisticsFields;
  // A later stage can revoke a row, but never resurrect one removed by a peer.
  return current
    .filter((item) => byName.has(item.model_name))
    .map((item) => ({
      ...item,
      ...Object.fromEntries(
        fields.map((key) => [key, byName.get(item.model_name)[key]])
      ),
      [`${stage}_state_v1020`]: 'ready',
    }));
}

export function catalogStageTextV1020(language, stage, state) {
  const zh = language?.startsWith('zh');
  if (stage === 'prices')
    return state === 'pending'
      ? zh
        ? '\u4ef7\u683c\u52a0\u8f7d\u4e2d...'
        : 'Loading prices...'
      : zh
      ? '\u4ef7\u683c\u6682\u65f6\u65e0\u6cd5\u52a0\u8f7d'
      : 'Prices temporarily unavailable';
  return state === 'pending'
    ? zh
      ? '\u7edf\u8ba1\u52a0\u8f7d\u4e2d...'
      : 'Loading statistics...'
    : zh
    ? '\u7edf\u8ba1\u6682\u65f6\u65e0\u6cd5\u52a0\u8f7d'
    : 'Statistics temporarily unavailable';
}
